<template>
  <div class="templates">
    <section class="section">
      <b-loading :active="isParentLoading"></b-loading>
      <div class="container">
        <div class="columns">
          <div class="column is-full">
            <div class="box">
              <div class="columns">
                <div class="column">
                  <header class="heading">
                    <p class="modal-card-title">{{ this.$t('templates-view.title') }}</p>
                  </header>
                </div>
                <div class="column is-narrow">
                  <b-button class="button" @click="backClicked" icon-left="arrow-left-bold">
                    {{ $t('common.back') }}
                  </b-button>
                </div>
              </div>
              <b-table class="templates-table" :data="templatesData" :striped="true" :hoverable="false"
                       :mobile-cards="true" :loading="isLoading" :scrollable="true">

                <b-table-column field="template.code" :label="this.$t('templates-view.template-code-column')"
                                v-slot="props" sortable searchable>
                  <a :href="projectDetailsLink(props.row.template.document_id)">{{ props.row.template.code }}</a>
                </b-table-column>

                <b-table-column v-slot="props" cellClass="has-text-right">
                  <b-button v-if="currentUserAccess('ProjectTemplates', UserActions.CREATE)"
                            class="button is-primary is-small" icon-left="plus-thick" style="margin-left: 8px"
                            @click="createProjectFromTemplateClicked(props.row.template.document_id)">
                    {{ $t('templates-view.create-project') }}
                  </b-button>
                  <b-button v-if="currentUserAccess('ProjectTemplates', UserActions.DELETE)"
                            class="button is-primary is-danger is-small" icon-left="delete" style="margin-left: 8px"
                            @click="deleteTemplateClicked(props.row.template.document_id)">
                    {{ $t('templates-view.delete-template-title') }}
                  </b-button>
                </b-table-column>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Templates",
  data() {
    return {
      templatesData: [],
      isLoading: false,
      isParentLoading: false
    }
  },
  methods: {
    readTemplatesData: function () {
      this.isLoading = true
      this.templatesData = []
      const functions = firebase.app().functions("europe-west3");
      const getProjectsFunction = functions.httpsCallable(this.getSubmitEndpoint());
      getProjectsFunction({action: "get_templates"})
          .then((result) => {
            console.log("templates result: ", result.data);
            result.data["projects"].forEach((template) => {
              this.templatesData.push({
                template: template
              });
            });
            this.isLoading = false
          })
          .catch((error) => {
            this.showError(error.message)
            console.log("Error getting templates: ", error);
            this.isLoading = false;
          });
    },
    projectDetailsLink: function (projectId) {
      if (this.currentUserAccess("ProjectDetails", this.UserActions.VIEW, projectId))
        return "#/projects/" + projectId;
      else
        return "#/projects/";
    },
    showProjectDetails: function (projectId) {
      this.$router.push({
        name: 'ProjectDetails',
        params: {
          id: projectId
        }
      })
    },
    deleteTemplate: function (templateId) {
      this.isParentLoading = true;
      const functions = firebase.app().functions("europe-west3");
      const deleteTemplateFunction = functions.httpsCallable(this.getSubmitEndpoint());
      deleteTemplateFunction({
        action: "delete_project",
        document_id: templateId
      }).then(() => {
        this.isParentLoading = false;
        this.showSuccess(this.$t('templates-view.template-deleted'));
        this.readTemplatesData()
      }).catch((error) => {
        this.isParentLoading = false;
        this.showError(error.message)
        console.log("Error deleting template: ", error);
      });
    },
    createProjectFromTemplateClicked: function (templateId) {
      this.$buefy.dialog.prompt({
        message: this.$t('templates-view.save-as-project-title').toString(),
        inputAttrs: {
          type: 'text',
          placeholder: this.$t('templates-view.project-code-placeholder').toString()
        },
        confirmText: this.$t('common.save').toString(),
        cancelText: this.$t('common.cancel').toString(),
        trapFocus: true,
        closeOnConfirm: false,
        onConfirm: (value, {close}) => {
          this.isParentLoading = true;
          const functions = firebase.app().functions("europe-west3");
          const saveAsProjectFunction = functions.httpsCallable(this.getSubmitEndpoint());
          const payload = {action: "copy_project", document_id: templateId, code: value, save_as: "project"}
          saveAsProjectFunction(payload)
              .then((result) => {
                this.isParentLoading = false;
                close()
                console.log("saved project results:", result.data);
                this.showSuccess(this.$t('templates-view.save-project-success'))
                const insertedProjectId = result.data.payload["projects"].inserted[0].document_id
                if (insertedProjectId !== undefined) {
                  this.showProjectDetails(insertedProjectId)
                }
              })
              .catch((error) => {
                this.isParentLoading = false;
                this.showError(error.message)
                console.log("Error saving project: ", error);
              })
        }
      })
    },
    deleteTemplateClicked: function (templateId) {
      this.$buefy.dialog.confirm({
        title: this.$t('templates-view.delete-template-title').toString(),
        message: this.$t('templates-view.delete-template-message').toString(),
        confirmText: this.$t('templates-view.delete-template-button').toString(),
        cancelText: this.$t('common.cancel').toString(),
        type: 'is-danger',
        hasIcon: true,
        icon: 'delete',
        onConfirm: () => {
          this.deleteTemplate(templateId);
        }
      });
    },
    backClicked: function () {
      this.$router.back()
    }
  },
  mounted() {
    if (!this.currentUserAccess("ProjectTemplates", this.UserActions.VIEW)) {
      console.log("Page access denied.");
      this.$router.replace("/projects/").catch(() => {
      });
    }
    // load user details from the server on each projects list refresh.
    this.loadUserRoleFromServer();
    this.readTemplatesData();
  }
};
</script>

<style scoped>
.templates-table {
  margin-top: 16px;
}
</style>
